import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useEmptyStyles = makeStyles(theme => ({
  icon: {
    width: 48,
    height: 48,
    borderRadius: 10,
    border: `1px solid ${GRAY_COLORS[200]}`,
    marginBottom: 16
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 24,
    textAlign: 'center'
  }
}))
